import { useCreateMyEstimateMutation } from '@massilia/queries'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import { EstimateForm } from '@/routes/_blue_header/-components/forms/estimate-form'

/**
 * Nouvelle demande de devis depuis l'espace client.
 *
 * Page à part entière, et non plus un dialog : le formulaire fait plusieurs
 * écrans de haut et embarque des calendriers et des autocomplétions, que le
 * défilement imbriqué d'une modale rendait inutilisables sur mobile. Une page
 * apporte en prime le retour arrière du navigateur et une URL partageable.
 *
 * Le formulaire est celui du site public — seule la mutation change :
 * `POST /me/estimates` rattache la demande au compte au lieu d'upserter un
 * client par e-mail.
 */
export const Route = createFileRoute('/_authenticated/_layout/mes-devis_/nouvelle-demande')({
  component: NewEstimateRequestPage,
  staticData: {
    hero: {
      subtitle: 'Décrivez votre projet, nos équipes vous répondent sous 72 h',
      title: 'Nouvelle demande de devis',
    },
  },
})

export function NewEstimateRequestPage() {
  const navigate = useNavigate()
  const createMutation = useCreateMyEstimateMutation()

  const backToQuotes = () => void navigate({ to: '/mes-devis' })

  return (
    <main className="mx-auto flex w-full max-w-4xl flex-1 flex-col px-4 py-6 md:px-8 md:py-10">
      <EstimateForm
        onCancel={backToQuotes}
        onSuccess={() => {
          toast.success('Demande envoyée', {
            description: 'Nos équipes vous répondent sous 72 h.',
          })
          backToQuotes()
        }}
        submit={createMutation.mutateAsync}
      />
    </main>
  )
}
